// Requests
import PostCall from "./CommonApi";

const SendEmail = (props) => {
    let url = "/v1/ovra/util/receipt/SendMail";
    let requestObject = props;
    return PostCall(url,requestObject);
};

export default SendEmail;
